import offers from "./offers";

export const OFFERS_NAMESPACE = "offers";

export default offers;
